/**
 * Internal errors that we caused.
 *
 * File: \src\components\messages\handler\InternalError.ts
 * Created Date: Thursday, March 4th 2021, 13:29:37
 * Author: Sascha Herrmann
 * -----
 * Last Modified: March 4th 2021, 13:31:25
 * Modified By: Sascha Herrmann
 * -----
 * Copyright (c) 2017-2021 Liebherr-Hausgeräte GmbH
 */
import UserNotification from './UserNotification';
import { UserNotificationType } from './UserNotificationType';

/**
 * This is a UserError class which extends UserNotification.
 *
 * @export
 * @class UserError
 * @extends {UserNotification}
 */
export default class InternalError extends UserNotification {
  /**
   * The error message which will be embedded to service request.
   *
   * @type {string}
   * @memberof InternalError
   */
  public errorMessage: string = null;

  /**
   * The time the error occurred which will be embedded to service request.
   *
   * @type {Date}
   * @memberof InternalError
   */
  public errorTime: Date = null;

  /**
   * Creates an instance of InternalError.
   *
   * @param {string} text The text.
   * @param {string} [errorMessage] Error message - optional.
   * @param {Date} [errorTime] Error time - optional.
   * @memberof InternalError
   */
  constructor(text: string, errorMessage?: string, errorTime?: Date) {
    super(text, UserNotificationType.INTERNAL_ERROR);

    if (errorMessage && errorTime) {
      this.errorMessage = errorMessage;
      this.errorTime = errorTime;
    }
  }
}
